import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
import { LocalCacheService } from '../../../services/localCache.service';

@Component({
  selector: 'app-cruise-travel-insurance',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './cruise-travel-insurance.component.html',
  styleUrl: './cruise-travel-insurance.component.scss',
})
export class CruiseTravelInsuranceComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
    private localCacheService: LocalCacheService,
  ) {
    this.titleService.setTitle(
      'International Cruise Travel Insurance | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover cruise travel insurance helps protect your overseas cruise with cover for unexpected events. Get your cruise insurance quote online.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'International Cruise Travel Insurance | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover cruise travel insurance helps protect your overseas cruise with cover for unexpected events. Get your cruise insurance quote online.',
    });
  }

  ngOnInit() {
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
